import { getPadlockPincodes } from "../../Api Methods/Api";
import { useState } from "react";

export const useGetPasscodes = (apiData, dispatch) => {
    const [passcodes, setPasscodes] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showPasscodes, setShowPasscodes] = useState(false);

    const getPasscodes = async (lockID) => {
        setLoading(true);

        const response = await getPadlockPincodes(apiData, lockID, dispatch);
        if (response.sucess) {
            setPasscodes(response.data || []);
        } else {
            setPasscodes([]);
        }
        setShowPasscodes(true);
        setLoading(false);
    };

    return { passcodes, loading, setLoading, showPasscodes, setShowPasscodes, getPasscodes };
};